<script setup lang="ts">
import { Hash } from 'lucide-vue-next'

defineProps<{
  query: string
}>()

const t = useTranslator()
</script>

<template>
  <div class="py-12 text-center">
    <Hash class="w-8 h-8 text-muted-foreground/15 mx-auto mb-3" />
    <p class="text-[0.8125rem] text-muted-foreground">
      {{ t('CHROME_SEARCH_NO_RESULTS_FOR') }} <span class="text-foreground">"{{ query }}"</span>
    </p>
    <p class="text-[0.75rem] text-muted-foreground/50 mt-1">{{ t('CHROME_SEARCH_TRY_ANOTHER') }}</p>
  </div>
</template>
